import { queryKeys } from "@/lib/useQuery/queryKeys";
import { useQuery } from "@tanstack/react-query";
import { UseGetProjectByIdProps } from ".";

export function useGetProjectById({ projectId }: UseGetProjectByIdProps) {
    return useQuery({
        ...queryKeys.project.details({ projectId: projectId! }),
        enabled: !!projectId,
    });
}